import styled from 'styled-components';

const green = '#47b972';

export const Divider = styled.div`
  height: 1px;
  margin: 4px 0 0;
  background: #2c353d;
`;

export const SectionTitle = styled.div`
  padding: 12px 15px 6px;
  text-align: right;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #7a838a;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  height: 36px;
  box-sizing: border-box;
  padding: 0 15px;
  font-size: 13px;
  font-weight: 600;
  color: #e6eaec;
  cursor: pointer;
  user-select: none;
  transition: background 0.15s ease;
  &:hover {
    background: #232e35;
  }
  &.off {
    color: #7a838a;
  }
  &.loading {
    opacity: 0.6;
    pointer-events: none;
  }
  small {
    font-size: 12px;
    font-weight: 400;
    color: #7a838a;
  }
`;

export const Switch = styled.span`
  position: relative;
  flex: none;
  width: 32px;
  height: 18px;
  border-radius: 999px;
  background: #3a444b;
  transition: background 0.15s ease;
  &::after {
    content: '';
    position: absolute;
    top: 2px;
    left: 2px;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: #fff;
    transition: transform 0.15s ease;
  }
  &.on {
    background: ${green};
  }
  &.on::after {
    transform: translateX(14px);
  }
`;

export const Chevron = styled.button`
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  margin: 0 -6px 0 0;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #7a838a;
  cursor: pointer;
  &:hover {
    color: #e6eaec;
    background: rgba(255, 255, 255, 0.06);
  }
  svg {
    transition: transform 0.18s ease;
  }
  &.open svg {
    transform: rotate(180deg);
  }
`;

export const List = styled.div`
  margin: 0 0 6px 15px;
  padding: 0 0 4px;
  border-left: 2px solid ${green};
`;

export const SelectAll = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 6px 15px 4px;
  button {
    border: 0;
    background: transparent;
    padding: 0;
    font: inherit;
    font-size: 12px;
    color: #5b9dff;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  height: 36px;
  box-sizing: border-box;
  padding: 0 15px 0 12px;
  font-size: 13px;
  font-weight: 600;
  color: #e6eaec;
  cursor: pointer;
  border-top: 2px solid transparent;
  transition: background 0.15s ease;
  &:hover {
    background: #232e35;
  }
  &.hidden {
    color: #7a838a;
    font-weight: 400;
  }
  &.dragging {
    opacity: 0.4;
  }
  &.over {
    border-top-color: ${green};
  }
  .label {
    flex: 1;
    text-align: left;
  }
`;

export const Handle = styled.span`
  flex: none;
  display: inline-flex;
  color: #5a666d;
  cursor: grab;
  &:active {
    cursor: grabbing;
  }
`;

export const Check = styled.span`
  flex: none;
  box-sizing: border-box;
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border: 1px solid #3d4952;
  background: #10151a;
  &.on {
    background: ${green} url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23ffffff' stroke-width='3.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M20 6L9 17l-5-5'/%3E%3C/svg%3E") no-repeat center / 11px;
    border-color: ${green};
  }
`;
